import {
    TimelineConnector,
    TimelineContent,
    TimelineItemElement,
    TimelineOppositeContent,
} from "../TimelineItem.styles";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { HalftimeTitle, TimelineEnd } from "../GameTimeline.styles";
import React from "react";

export function MatchBreakEndEvent() {
    return (
        <TimelineItemElement>
            <TimelineOppositeContent />
            <TimelineSeparator>
                <TimelineConnector />
                <TimelineEnd />
                <HalftimeTitle>Halbzeit</HalftimeTitle>
            </TimelineSeparator>
            <TimelineContent />
        </TimelineItemElement>
    );
}
